/**
 * A product's full ingredient list (SSD-6639): one English display name per ingredient, in
 * packaging-label order. A synonym group such as "Water;Aqua" is already reduced to its first
 * name ("Water"); a slash stays part of the name. Empty when the catalog has no ingredient data.
 */
export type ProductIngredients = readonly string[];
